import { validateEmail, validatePhone } from '@paction-2.0/ui';

export const FIRST_NAME_MIN_LENGTH = 3;

type ContactFields = {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  provinceSlug: string;
  citySlug: string;
};

export const describeMissingContactRequirements = (
  fields: ContactFields
): string[] => {
  const firstName = fields.firstName.trim();
  const email = fields.email.trim();
  const phone = fields.phone?.trim() ?? '';

  return [
    !firstName && 'add your first name',
    firstName.length > 0 &&
      firstName.length < FIRST_NAME_MIN_LENGTH &&
      `use at least ${FIRST_NAME_MIN_LENGTH} letters in your first name`,
    !fields.lastName.trim() && 'add your last name',
    !email && 'add your email address',
    !!email && !!validateEmail(email) && 'check your email address',
    !!phone &&
      !!validatePhone(phone) &&
      'fix your mobile number (or leave it blank)',
    !fields.provinceSlug && 'choose your province',
    !!fields.provinceSlug && !fields.citySlug && 'choose your city'
  ].filter((requirement): requirement is string => !!requirement);
};

export const hasStartedContactForm = (fields: ContactFields): boolean =>
  [fields.firstName, fields.lastName, fields.email, fields.phone ?? ''].some(
    (value) => value.trim().length > 0
  );
